const UNIT_TO_MILLISECONDS = {
  sec: 1000,
  วินาที: 1000,
  second: 1000,
  seconds: 1000,
  min: 60 * 1000,
  นาที: 60 * 1000,
  minute: 60 * 1000,
  minutes: 60 * 1000,
  hr: 60 * 60 * 1000,
  ชั่วโมง: 60 * 60 * 1000,
  hour: 60 * 60 * 1000,
  hours: 60 * 60 * 1000,
  day: 24 * 60 * 60 * 1000,
  วัน: 24 * 60 * 60 * 1000,
  days: 24 * 60 * 60 * 1000,
};

export const extractApiList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

export const uniqueNonEmpty = (items) => [...new Set(
  items.filter((item) => item !== null && item !== undefined && String(item).trim() !== ''),
)];

export const addWipDuration = (startDate, value, unit) => {
  if (!(startDate instanceof Date) || Number.isNaN(startDate.getTime())) return null;
  const amount = Number(value);
  if (!Number.isFinite(amount)) return new Date(startDate.getTime());
  const multiplier = UNIT_TO_MILLISECONDS[String(unit || '').trim().toLowerCase()] || 1000;
  return new Date(startDate.getTime() + (amount * multiplier));
};

export const formatApiTime = (value) => {
  if (!(value instanceof Date) || Number.isNaN(value.getTime())) return '';
  const pad = (part) => String(part).padStart(2, '0');
  return `${pad(value.getHours())}:${pad(value.getMinutes())}:${pad(value.getSeconds())}`;
};

export const mapRegistrationToRow = (item) => ({
  id: item.id,
  date: item.created_at || '',
  matCode: item.mat_code || '',
  productName: item.product_name || '',
  type: item.type || '',
  start: item.start_time || '',
  end: item.end_time || '',
  lot: item.lot || '',
  batch: item.batch || '',
  shift: item.shift || '',
  weight: item.weight ?? '',
  qty: item.qty ?? '',
  unit: item.unit || '',
  location: item.location || '',
  component: item.components || '',
  processStep: item.process_step || '',
  ref: item.ref || '',
  no: item.no || '',
  createdBy: item.created_by || '',
});

